const { default: Swiper } = require('swiper');
const { Pagination, Mousewheel } = require('swiper/modules');
const { swiperPagination } = require('../modules/swiperModules');

const sections = document.querySelectorAll('section.blog');

if (sections.length) {
    sections.forEach(section => {
        const swiperElement = section.querySelector('.swiper');
        const paginationElement =
            swiperElement?.querySelector('.slider-pagination');

        if (!swiperElement) return;
        const slides = swiperElement.querySelectorAll('.swiper-slide');
        if (slides.length === 1) return;

        let swiper = null;

        const createSwiper = () => {
            let args = {
                slidesPerView: 1.08,
                spaceBetween: 16,
                modules: [Pagination, Mousewheel],
                direction: 'horizontal',
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                    invert: false,
                },
            };

            if (paginationElement) {
                args = { ...args, ...swiperPagination(paginationElement) };
            }

            swiper = new Swiper(swiperElement, args);
        };

        const destroySwiper = () => {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        };

        const handleSwiper = () => {
            if (window.innerWidth >= 1024) {
                destroySwiper();
            } else {
                if (!swiper) {
                    createSwiper();
                }
            }
        };

        // initial check
        handleSwiper();

        window.addEventListener('resize', handleSwiper);
    });
}
